export const SIZE_UNIT = 'm';
export const BOOKING_DAY_START_HOUR = 12;
